import React, { Component } from 'react';
import { Form, Row, Col } from 'reactstrap';
import { request, request_file } from './request.js';
import Swal from 'sweetalert2'
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import 'jquery/dist/jquery.min.js';
import './App.css';
import './fonts/css/open-iconic.css';
import 'animate.css';
import imagen from './imagenes/hombre.png';



class MainAdmin extends Component 
{
	constructor(props)
	{
		super(props)
		this.state = {
			registro :
			{
				curp : '',
				nombre : '',
				apellido1 : '',
				grupo : '',
				dia1 : '',
				mes1 : '',
				anio1 : '',
				dia2 : '',
				mes2 : '',
				anio2 : '',
				tipo : '',
			},
			movimientos : [],
			foto : imagen,
		}
		this.buscarEntradas = this.buscarEntradas.bind(this);
	}

	submit=(evt)=>{
		evt.preventDefault();
	}

	handleInputChange=(event)=>
	{
		const target = event.target;
		const value = target.value;
		const name = target.name;

		var { registro } = this.state;

		registro[name] = value;

		this.setState({ registro : registro });
	}

	buscarEntradas(e,tipo)
	{
		var { registro, movimientos, foto } = this.state;
		//var arreglo = movimientos;
		let temp = this;

		var OK=false;

		registro['tipo']=tipo;
		console.log(registro['curp'].length);

		switch(tipo)
		{
			case 1:
				if(registro['curp'].length !== 18)
				{
					Swal.fire({
						toast: true,
						icon: 'warning',
						title: 'El Curp no es valido',
						showConfirmButton: false,
						timer: 3000
					});
				}
				else
				{
					OK=true;
				}
			break;

			case 2:
				if(registro['nombre'].length < 3)
				{
					Swal.fire({
						toast: true,
						icon: 'warning',
						title: 'Debes escribir al menos 3 letras del nombre',
						showConfirmButton: false,
						timer: 3000
					});
				}
				else
				{
					OK=true;
				}
			break;

			case 3:
				if(registro['apellido1'].length < 3)
				{
					Swal.fire({
						toast: true,
						icon: 'warning',
						title: 'Debes escribir al menos 3 letras del apellido',
						showConfirmButton: false,
						timer: 3000
					});
				}
				else
				{
					OK=true;
				}
			break;

			case 4:
				if(registro['grupo'].length !== 2)
				{
					Swal.fire({
						toast: true,
						icon: 'warning',
						title: 'Debes escribir solo grado y grupo',
						showConfirmButton: false,
						timer: 3000
					});
				}
				else
				{
					OK=true;
				}
			break;
		}

		if(OK)
		{
			request.post('/ConsultarEntradasAdmin',registro)
			.then(function(response)
			{
				if(response.status === 200)
				{
					if(response.data)
					{
			 			//registro = response.data.registro;
			 			movimientos = response.data.movimientos;
			 			temp.setState({ registro : registro, movimientos : movimientos });
			 		}
			 		else
			 		{
			 			registro.curp="";
			 			registro.nombre="";
			 			registro.apellido1="";
			 			registro.grupo="";
		 				Swal.fire({
							position: 'top-end',
							icon: 'error',
							title: 'No Registrado',
							toast: true,
							showConfirmButton: false,
							timer: 1500
						});
			 			temp.setState({ registro : registro });
			 		}
			 	}
			})
			.catch(error => {} );
			console.log(registro['curp']);

			request_file().post(`/MostrarImagen?curp=${registro['curp']}`)
			.then(response =>
			{
				const file = new Blob([response.data], {type: 'image/jpeg' });
				const fileURL = URL.createObjectURL(file);
				foto=fileURL;
				temp.setState({ foto : foto });
			})
			.catch(error => { });

			this.setState({ registro : registro, movimientos : movimientos });
		}
	}

	render()
	{

		let { registro, movimientos, foto } = this.state;
		const semana = ["Domingo","Lunes","Martes","Miercoles","Jueves","Viernes","Sabado"];
		const meses = ["","Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"];

		return (
			<div className="body">
				<div className="main">
					<Row className="pl-1 pr-1">
						<Col className="col-12">
							<Form onSubmit={this.submit}>
								<Row>
									<Col>
										<div className="pl-1 pr-1 input-group mb-1 loginForm">
											<span className="input-group-text" id="basic-addon1"> Consulta de Entradas y Salidas </span>
											<input type="text" disabled className="form-control" />
											<span className="input-group-text">Esc. Sec. #5 Moises Saenz Garza</span>
										</div>
									</Col>
								</Row>
							</Form>
		{/* CUADRO DE FOTO */}					
							<Row>
								<Col>
									<div className="pl-2 pr-2 input-group mb-1 loginForm">
										<table>
											<tr className="f ml-2">
												<td className="f">
													<img className="cuadroFoto" align="middle" src={foto} class="img-thumbnail" alt="..."/>
												</td>
												<td className="datos">
													<div className="pr-1 input-group mb-1">
														<span className="input-group-text" id="basic-addon1"> CURP: </span>
														<input type="text" autoFocus autoComplete="off" name="curp" id="curp" className="form-control" placeholder="Escribe el CURP a consultar" aria-label="Credencial" aria-describedby="basic-addon1" onChange={this.handleInputChange}/>
														<button className="btn btn-primary" type="button" id="button-addon2" onClick={(e)=>this.buscarEntradas(e,1)}>BUSCAR</button>
													</div>
													<div className="pr-1 input-group mb-1">
														<span className="input-group-text" id="basic-addon1"> NOMBRE(S): </span>
														<input type="text" className="form-control" aria-label="nombre" name="nombre" id="nombre" value={registro.nombre} onChange={this.handleInputChange}/>
														<button className="btn btn-primary" type="button" id="button-addon2" onClick={(e)=>this.buscarEntradas(e,2)}>BUSCAR</button>
													</div>
													<div className="pr-1 input-group mb-1">
														<span className="input-group-text" id="basic-addon1"> APELLIDOS: </span>
														<input type="text" className="form-control" aria-label="apellido1" name="apellido1" id="apellido1" value={registro.apellido1} onChange={this.handleInputChange}/>
														<button className="btn btn-primary" type="button" id="button-addon2" onClick={(e)=>this.buscarEntradas(e,3)}>BUSCAR</button>
													</div>
													<div className="pr-1 input-group mb-3">
														<span className="input-group-text" id="basic-addon1"> GRUPO: </span>
														<input type="text" className="form-control" aria-label="grupo" name="grupo" id="grupo" value={registro.grupo} onChange={this.handleInputChange}/>
														<button className="btn btn-primary" type="button" id="button-addon2" onClick={(e)=>this.buscarEntradas(e,4)}>BUSCAR</button>
													</div>
													<div className="pr-1 input-group mb-1">
														<span className="input-group-text" id="basic-addon1"> Inicio: </span>
														<select className="custom-select" name="dia1" value={registro.dia1} id="dia1" onChange={this.handleInputChange}>
															<option value="">Dia</option>
															<option value="01">1</option>
															<option value="02">2</option>
															<option value="03">3</option>
															<option value="04">4</option>
															<option value="05">5</option>
															<option value="06">6</option>
															<option value="07">7</option>
															<option value="08">8</option>
															<option value="09">9</option>
															<option value="10">10</option>
															<option value="11">11</option>
															<option value="12">12</option>
															<option value="13">13</option>
															<option value="14">14</option>
															<option value="15">15</option>
															<option value="16">16</option>
															<option value="17">17</option>
															<option value="18">18</option>
															<option value="19">19</option>
															<option value="20">20</option>
															<option value="21">21</option>
															<option value="22">22</option>
															<option value="23">23</option>
															<option value="24">24</option>
															<option value="25">25</option>
															<option value="26">26</option>
															<option value="27">27</option>
															<option value="28">28</option>
															<option value="29">29</option>
															<option value="30">30</option>
															<option value="31">31</option>
														</select>
														<select className="custom-select" name="mes1" value={registro.mes1} id="mes1" onChange={this.handleInputChange}>
															<option value="">Mes</option>
															<option value="01">Enero</option>
															<option value="02">Febrero</option>
															<option value="03">Marzo</option>
															<option value="04">Abril</option>
															<option value="05">Mayo</option>
															<option value="06">Junio</option>
															<option value="07">Julio</option>
															<option value="08">Agosto</option>
															<option value="09">Septiembre</option>
															<option value="10">Octubre</option>
															<option value="11">Noviembre</option>
															<option value="12">Diciembre</option>
														</select>
														<select className="custom-select" name="anio1" value={registro.anio1} id="anio1" onChange={this.handleInputChange}>
															<option value="">Año</option>
															<option value="2025">2025</option>
															<option value="2026">2026</option>
															<option value="2027">2027</option>
															<option value="2028">2028</option>
															<option value="2029">2029</option>
														</select>
													</div>
													<div className="pr-1 input-group mb-1">
														<span className="input-group-text" id="basic-addon1"> Fin: </span>
														<select className="custom-select" name="dia2" value={registro.dia2} id="dia2" onChange={this.handleInputChange}>
															<option value="">Dia</option>
															<option value="01">1</option>
															<option value="02">2</option>
															<option value="03">3</option>
															<option value="04">4</option>
															<option value="05">5</option>
															<option value="06">6</option>
															<option value="07">7</option>
															<option value="08">8</option>
															<option value="09">9</option>
															<option value="10">10</option>
															<option value="11">11</option>
															<option value="12">12</option>
															<option value="13">13</option>
															<option value="14">14</option>
															<option value="15">15</option>
															<option value="16">16</option>
															<option value="17">17</option>
															<option value="18">18</option>
															<option value="19">19</option>
															<option value="20">20</option>
															<option value="21">21</option>
															<option value="22">22</option>
															<option value="23">23</option>
															<option value="24">24</option>
															<option value="25">25</option>
															<option value="26">26</option>
															<option value="27">27</option>
															<option value="28">28</option>
															<option value="29">29</option>
															<option value="30">30</option>
															<option value="31">31</option>
														</select>
														<select className="custom-select" name="mes2" value={registro.mes2} id="mes2" onChange={this.handleInputChange}>
															<option value="">Mes</option>
															<option value="01">Enero</option>
															<option value="02">Febrero</option>
															<option value="03">Marzo</option>
															<option value="04">Abril</option>
															<option value="05">Mayo</option>
															<option value="06">Junio</option>
															<option value="07">Julio</option>
															<option value="08">Agosto</option>
															<option value="09">Septiembre</option>
															<option value="10">Octubre</option>
															<option value="11">Noviembre</option>
															<option value="12">Diciembre</option>
														</select>
														<select className="custom-select" name="anio2" value={registro.anio2} id="anio2" onChange={this.handleInputChange}>
															<option value="">Año</option>
															<option value="2025">2025</option>
															<option value="2026">2026</option>
															<option value="2027">2027</option>
															<option value="2028">2028</option>
															<option value="2029">2029</option>
														</select>
													</div>
												</td>
											</tr>
										</table>
									</div>
								</Col>
							</Row>
								
		{/* LISTA DE REPORTE */}
							<Form>
								<Row>
									<Col>
										<div className="pl-2 pr-2 loginForm maxh lista">
											<table className="table table-responsive-sm table-striped table-bordered table-sm">
												<tbody>
												{
													movimientos.map((item, i) => 
														<tr>
															<td className="cm cen ne"> { i+1 } </td>
															{
																(item.tipo)==='E' ?
																	<td className="cc cen"> <span className="oi ve" data-glyph="arrow-thick-top" aria-hidden="true"></span> </td>
																:
																	(item.tipo)==='S' ?
																		<td className="cc cen"> <span className="oi ro" data-glyph="arrow-thick-bottom" aria-hidden="true"></span> </td>
																	:
																		<td className="cc cen"> </td>
															}
															<td className="cx cen ne"> {item.apellido1}, {item.nombre}</td>
															<td className="cx cen ne"> {semana[item.diasem]} {item.dia} de {meses[parseInt(item.mes,10)]} del {item.anio}. </td>
															<td className="cm cen ne"> {item.grupo } </td>
															<td className="cm cen ne"> {item.responsable } </td>
															<td className="cm cen ne"> {item.puerta } </td>
															{/*<td className="cm cen ne"> {item.tipo } </td>*/}
															<td className="cg cen ne"> {item.hora} </td>
														</tr>
													)
												}
												</tbody>
											</table>
										</div>
									</Col>
								</Row>
							</Form>
							
						</Col>
					</Row>
				</div>
			</div>
		);
	}
}

export default MainAdmin;